import SimpleSchema from 'simpl-schema';
import { isEmpty, isNil } from 'lodash';

const REQUIRED_ERROR = SimpleSchema.ErrorTypes.REQUIRED;

/**
 * Function to make a field required a condition is met.
 *
 * @param {object} arg - The argument parameter.
 * @param {boolean} arg.shouldBeRequired - The condition for the value to be required.
 * @param {object} arg.schemaInstance - The simple schema instace for validation.
 * @param {boolean} [arg.shouldArrayBeEmpty=true] - For array fields, it can be empty.
 * @param {boolean} [arg.shouldStringBeEmpty=true] - For string fields, it can be empty.
 * @returns {SimpleSchema.ErrorTypes.REQUIRED} Error if the field should be required.
 */
const requiredIf = ({
  requiredCondition,
  schemaInstance,
  shouldArrayBeEmpty = true,
  shouldStringBeEmpty = false
}) => {
  if (requiredCondition) {
    // inserts
    const fieldValue = schemaInstance.value;
    const mongoOperator = schemaInstance.operator;
    const isFieldSet = schemaInstance.isSet;
    if (!mongoOperator) {
      if (!isFieldSet || isNil(fieldValue)) return REQUIRED_ERROR;
      if (!shouldArrayBeEmpty && isEmpty(fieldValue)) return REQUIRED_ERROR;
      if (!shouldStringBeEmpty && fieldValue === '') return REQUIRED_ERROR;
    } else if (isFieldSet) {
      // updates
      if (mongoOperator === '$set') {
        if (isNil(fieldValue)) return REQUIRED_ERROR;
        if (!shouldArrayBeEmpty && isEmpty(fieldValue)) return REQUIRED_ERROR;
        if (fieldValue === '') return REQUIRED_ERROR;
      }
      if (mongoOperator === '$unset') return REQUIRED_ERROR;
      if (mongoOperator === '$rename') return REQUIRED_ERROR;
    }
  }
  /** If validation is correct return undefined
   * {@link https://github.com/aldeed/simple-schema-js#custom-field-validation}.
   */
  return undefined;
};

export default requiredIf;
